import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pasteButton: {
    id: 'course-authoring.course-outline.subsection.button.paste-unit',
    defaultMessage: 'Paste unit',
    description: 'Message of the button to paste a new unit in a subsection.',
  },
  unitPickerModalTitle: {
    id: 'course-authoring.course-outline.subsection.unit.modal.single-title.text',
    defaultMessage: 'Select unit',
    description: 'Library unit picker modal title.',
  },
});

export default messages;
